import { createPortal } from 'react-dom'
import { Link, useLocation } from 'react-router-dom'
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from '@mui/material'
import { MobileNavItem } from './navigation/types'

type MobileNavigationProps = {
  items: MobileNavItem[]
}

export function MobileNavigation({ items }: MobileNavigationProps) {
  const { pathname } = useLocation()

  return (
    <>
      {createPortal(
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        px: 3,
        pt: 2,
        pb: 'calc(12px + env(safe-area-inset-bottom, 0px))',
        pointerEvents: 'none',
        background:
          'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 28%)',
      }}
    >
      <Paper
        sx={{
          pointerEvents: 'auto',
          overflow: 'visible',
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: 2,
        }}
        variant="elevation"
        elevation={2}
      >
        <BottomNavigation
          value={pathname}
          sx={{
            '& .MuiBottomNavigationAction-root': { paddingX: 1 },
            backgroundColor: 'transparent',
          }}
        >
          {items.map(({ route, icon }) => (
            <BottomNavigationAction
              key={route}
              component={Link}
              to={route}
              value={route}
              icon={icon}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>,
    document.body,
      )}
    </>
  )
}
